import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReviewStatus } from '../../enum/review.status';
import { Rank } from '../../class/rank';

// Célula da coluna "Notas individuais" (mini-tabela de scores) extraída para um componente
// OnPush próprio. Assim, quando o pai re-checa (ex.: toggle "Colorir linhas com status",
// scroll, filtro), esta célula só é re-avaliada se um dos @Inputs mudar de referência — como
// o toggle NÃO muda nenhum input dela, o Angular pula a re-checagem das milhares de células.
// Os estilos vivem no partial GLOBAL src/sass/components/_score-grid.scss (compartilhado com o
// cabeçalho, que segue no <th> do pai).
@Component({
  selector: 'app-score-cell',
  templateUrl: './score-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreCellComponent {
  @Input() rank: Rank;
  @Input() labels: string[] = [];        // critérios (shortLabels)
  @Input() ranges: string[] = [];        // faixa min–max por critério (tooltip das células de score)
  @Input() gridCols = '';                // grid-template-columns
  @Input() spanCols = 2;                 // colspan da revisão incompleta
  @Input() showReviewer = false;         // coluna Revisor visível?
  @Input() eventId: number;              // p/ o routerLink do revisor

  constructor(private translate: TranslateService) {}

  // Separador decimal por idioma (vírgula em pt). Igual ao locNum do pai.
  public locNum(value: any): string {
    if (value == null) { return ''; }
    const s = String(value);
    return (this.translate.currentLang || '').toLowerCase().startsWith('pt') ? s.replace('.', ',') : s;
  }

  public getReviewStatusIcon(status: string): { fontSet: string, fontIcon: string } {
    return ReviewStatus.icon(status as ReviewStatus);
  }
}
